import { render, staticRenderFns } from "./SVG_Filters.vue?vue&type=template&id=013a85d0&scoped=true"
import script from "./SVG_Filters.vue?vue&type=script&lang=js"
export * from "./SVG_Filters.vue?vue&type=script&lang=js"
import style0 from "./SVG_Filters.vue?vue&type=style&index=0&id=013a85d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013a85d0",
  null
  
)

export default component.exports